import { isUUID } from "../../utils";
import { db } from "../model";

async function addDataset(datasets) {
  const datasetsToInsert = [];

  for (const dataset of datasets) {
    const existingDataset = await db.datasets
      .where("uuid")
      .equals(dataset.id)
      .first();

    if (!existingDataset) {
      datasetsToInsert.push({
        uuid: dataset.id,
        name: dataset.name,
        projectID: dataset.project,
        schema: dataset.schema,
      });
    }
  }

  if (datasetsToInsert.length > 0) {
    await db.datasets.bulkPut(datasetsToInsert);
    console.log("New datasets stored in the database.");
  } else {
    console.log("No new datasets to insert");
  }
}

async function getDataset() {
  var projectId = localStorage.getItem("project_id");
  if (isUUID(projectId)) {
    projectId = await db.projects.where("uuid").equals(projectId).first();
    projectId = projectId.id;
  }
  if (typeof projectId !== "number") {
    projectId = parseInt(projectId, 10);
  }
  const project = await db.projects.where("id").equals(projectId).first();

  if (project) {
    const project_uuid = project.uuid;
    const storedDatasets = await db.datasets
      .where("projectID")
      .equals(project_uuid)
      .toArray();
    return storedDatasets;
  } else {
    return [];
  }
}

async function getDatasetByUUID(uuid) {
  const dataset = await db.datasets.where("uuid").equals(uuid).first();
  return dataset;
}

export { addDataset, getDataset, getDatasetByUUID };
